import { initiateTracking } from "../../../../../../utils/commonUtil";

export const analyticsTracking = (buttonName, tab) => {
  const page = "Grant Activity";
  const tabMapper = tab => {
    switch (tab) {
      case "1":
        return "Grants";
      case "2":
        return "View & Edit Grant Schedule";
      case "3":
        return "Grant Agreements";
    }
  };
  
  switch (buttonName) {
    case "export":
      return initiateTracking("export", page, "", `Export - ${tabMapper(tab)}`);
    case "print":
      return initiateTracking("print", page, "", `Print - ${tabMapper(tab)}`);
    case "tab":
      return initiateTracking("tabClick", page, "", `${tabMapper(tab)}`);
    case "view":
      return initiateTracking("viewEdit", page, "", `View - ${tabMapper(tab)}`);
    case "viewEdit":
      return initiateTracking("viewEdit", page, "", `View & Edit - ${tabMapper(tab)}`);
    case "cancel":
      return initiateTracking("cancel2", page, "", `Cancel - ${tabMapper(tab)}`);
    default:
      break;
  }
};
